import $olgm$OLGoogleMaps from './olgm/OLGoogleMaps';
import $olgm$gm$ImageOverlay from './olgm/gm/ImageOverlay';
import $olgm$gm$MapElement from './olgm/gm/MapElement';
import $olgm$gm$MapIcon from './olgm/gm/MapIcon';
import $olgm$gm$MapLabel from './olgm/gm/MapLabel';
import $olgm$gm$PanesOverlay from './olgm/gm/PanesOverlay';
import $olgm$herald$ImageWMSSource from './olgm/herald/ImageWMSSource';
import $olgm$herald$Layers from './olgm/herald/Layers';
import $olgm$herald$Source from './olgm/herald/Source';
import $olgm$herald$TileSource from './olgm/herald/TileSource';
import $olgm$herald$VectorSource from './olgm/herald/VectorSource';
import $olgm$layer$Google from './olgm/layer/Google';
import * as _olgm_interaction from './olgm/interaction';

var olgm = window['olgm'] = {};

olgm.gm = {};
olgm.interaction = {};
olgm.layer = {};
olgm.OLGoogleMaps = $olgm$OLGoogleMaps;
olgm.gm.ImageOverlay = $olgm$gm$ImageOverlay;
olgm.gm.MapElement = $olgm$gm$MapElement;
olgm.gm.MapIcon = $olgm$gm$MapIcon;
olgm.gm.MapLabel = $olgm$gm$MapLabel;
olgm.gm.PanesOverlay = $olgm$gm$PanesOverlay;
olgm.interaction.defaults = _olgm_interaction.defaults;
olgm.layer.Google = $olgm$layer$Google;
